import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Table from "./Table";
import Filter from "./Filter";
import { useDispatch, useSelector } from "react-redux";
import { GetCustomerReport } from "../../../../../../../features/admin/report_generator/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const Internal_Audit = ({
  managementdetails,
  setCurrentPage,
  currentPage,
  setSearchParams,
  reportgenerate,
}) => {
  const [show, setShow] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReportPermission = permissions?.includes(
    FixIDS.internal_audit_report.Report,
  );

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Filter
          setShow={setShow}
          setSearchParams={setSearchParams}
          reportgenerate={reportgenerate}
        />
      </div>

      <div className="report_table_div">
        {haveReportPermission && (
          <Table
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            managementdetails={managementdetails}
          />
        )}
      </div>
    </section>
  );
};

export default Internal_Audit;
